import ThankYouPage from './thank-you-page';
export default ThankYouPage;